export const UPDATE_HEADER_TITLE = 'Headers/UPDATE_HEADER_TITLE';

export const updateHeaderTitle = (id, title) => {
  return {
    type: UPDATE_HEADER_TITLE,
    id,
    title,
  };
};



// WEBPACK FOOTER //
// ./src/actions/headers.js